import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import AuroraBackground from '../components/AuroraBackground/AuroraBackground';
import AuroraNavbar from '../components/AuroraNavbar/AuroraNavbar';
import Footer from '../components/Footer';
import MetaHead from '../components/MetaHead';
import '../styles/pg-howitworks.css';

export default function HowItWorks() {
  const navigate = useNavigate();
  const { t } = useTranslation(['howItWorks', 'common']);

  const bossList = t('boss.list', { returnObjects: true }) || [];

  return (
    <>
      <MetaHead page="howItWorks" />
      <AuroraBackground />
      <AuroraNavbar activeLink="how" />

      <main className="pg-how">

        {/* HERO */}
        <section className="pg-how-hero">
          <h1 className="pg-how-h1">{t('hero.title')}</h1>
          <p className="pg-how-hero-sub">{t('hero.subtitle')}</p>
        </section>

        {/* 3 ÉTAPES */}
        <section className="pg-how-section">
          <div className="pg-how-section-inner">
            <h2 className="pg-how-h2">{t('steps.title')}</h2>
            <div className="pg-how-vsteps">
              <div className="pg-how-vstep">
                <div className="pg-how-vstep-num">1</div>
                <div className="pg-how-vstep-content">
                  <div className="pg-how-vstep-title">{t('steps.step1_title')}</div>
                  <div className="pg-how-vstep-desc">{t('steps.step1_desc')}</div>
                </div>
              </div>
              <div className="pg-how-vstep">
                <div className="pg-how-vstep-num">2</div>
                <div className="pg-how-vstep-content">
                  <div className="pg-how-vstep-title">{t('steps.step2_title')}</div>
                  <div className="pg-how-vstep-desc">{t('steps.step2_desc')}</div>
                </div>
              </div>
              <div className="pg-how-vstep">
                <div className="pg-how-vstep-num">3</div>
                <div className="pg-how-vstep-content">
                  <div className="pg-how-vstep-title">{t('steps.step3_title')}</div>
                  <div className="pg-how-vstep-desc">{t('steps.step3_desc')}</div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* CÔTÉ CLIENT */}
        <section className="pg-how-section">
          <div className="pg-how-section-inner">
            <h2 className="pg-how-h2">{t('client.title')}</h2>
            <div className="pg-how-cards-row">
              <div className="pg-how-side-card">
                <div className="pg-how-side-title">{t('client.card1_title')}</div>
                <div className="pg-how-side-desc">{t('client.card1_desc')}</div>
              </div>
              <div className="pg-how-side-card">
                <div className="pg-how-side-title">{t('client.card2_title')}</div>
                <div className="pg-how-side-desc">{t('client.card2_desc')}</div>
              </div>
              <div className="pg-how-side-card">
                <div className="pg-how-side-title">{t('client.card3_title')}</div>
                <div className="pg-how-side-desc">{t('client.card3_desc')}</div>
              </div>
            </div>
          </div>
        </section>

        {/* CÔTÉ PATRON */}
        <section className="pg-how-section">
          <div className="pg-how-section-inner">
            <h2 className="pg-how-h2">{t('boss.title')}</h2>
            <div className="pg-how-two-cols">
              <ul className="pg-how-dash-list">
                {bossList.map((item, i) => (
                  <li key={i}><span className="pg-how-dash">—</span>{item}</li>
                ))}
              </ul>
              <div className="pg-how-mockup">
                <div className="pg-how-mockup-label">{t('boss.mockup_label')}</div>
                <div className="pg-how-mockup-rps-label">RPS™</div>
                <div className="pg-how-mockup-rps-value">
                  92<span className="pg-how-mockup-denom">/100</span>
                </div>
                <div className="pg-how-mockup-sep" />
                <div className="pg-how-mockup-row">
                  <span className="pg-how-mockup-key">{t('boss.mockup_note_google')}</span>
                  <span className="pg-how-mockup-val">4,3 ★</span>
                </div>
                <div className="pg-how-mockup-row">
                  <span className="pg-how-mockup-key">{t('boss.mockup_this_month')}</span>
                  <span className="pg-how-mockup-val-green">{t('boss.mockup_this_month_value')}</span>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* CTA FINAL */}
        <section className="pg-how-cta">
          <h2 className="pg-how-h2">{t('cta_final.title')}</h2>
          <button className="pg-how-cta-btn" onClick={() => navigate('/register')}>
            {t('cta_final.cta')}
          </button>
          <div className="pg-how-cta-note">{t('cta_final.note')}</div>
        </section>

      </main>

      <Footer />
    </>
  );
}
